import React from 'react';
import Grid from '@material-ui/core/Grid';
import LaunchIcon from '@material-ui/icons/Launch';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { buttonStyles } from '../constants/theme/styles/components/buttonstyles';
import { downloadDomoReport } from '../helpers/file-helpers';

interface Props {
	domoLink: string;
	linkText: string;
}

export const DomoLink = (props: Props) => {
	const { domoLink, linkText } = props;
	const buttonClasses = buttonStyles();

	const token = useSelector<TcsmStates, string>(state => state?.authenticatedState?.accessToken);
	return (
    <Grid>
      <button className={buttonClasses.linkButton} type='button' onClick={() => downloadDomoReport(domoLink, token)} ><LaunchIcon /><span>{linkText}</span></button>
    </Grid>
	);
};
